var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavbarBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 321,
    viewBox: "0 0 430 321",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M331.237 159.903C278.38 81.5598 207.483 30.5047 118.557 6.73314C29.6324 -17.0385 -25.509 22.1354 -46.8587 124.245C-68.2084 226.36 -63.5442 319.013 -32.866 402.209C-2.18779 485.405 57.9264 534.641 147.477 549.921C237.027 565.202 303.256 523.604 346.163 425.132C389.071 326.656 384.094 238.246 331.237 159.903Z",
    fill: "#99CBC7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_273_35693)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_273_35693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.836 60.5215V327.638C377.836 343.714 377.609 358.136 376.799 371.643C378.095 346.765 377.22 319.832 377.22 319.832V60.9551C377.334 60.8748 377.415 60.8106 377.496 60.7624C377.706 60.6018 377.819 60.5215 377.836 60.5215Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M173.306 184.245V334.762C170.974 335.325 168.611 335.79 166.214 336.192C157.859 337.605 149.197 338.167 141.004 338.264C134.09 338.344 127.209 337.91 120.409 336.979V179.828L166.214 183.65L173.306 184.245Z",
    fill: "#99CBC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M293.412 328.785C290.074 385.662 273.811 429.772 239.347 461.335V208.072L294.533 223.403C294.533 223.403 294.935 262.193 294.533 287.045C294.268 303.348 294.533 309.691 293.412 328.785Z",
    fill: "#99CBC7"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_273_35693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.409 179.801V336.968C106.582 335.072 93.0781 331.106 80.3354 325.131V209.561L120.409 179.801V179.801Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_273_35693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.771 208.42V461.017C225.75 476.564 207.583 488.93 184.008 497.924C180.608 499.225 177.014 500.285 173.306 501.152C170.974 501.714 168.61 502.18 166.214 502.582V263.555L239.771 208.42Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_273_35693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.798 371.649C376.766 371.89 376.815 380.121 376.798 380.362C376.313 388.152 375.584 387.645 374.596 394.952C374.596 395.065 374.58 395.193 374.548 395.306C374.111 398.18 373.593 400.798 372.994 403.079C358.729 458.278 337.599 496.903 313.749 523.724C292.959 547.092 270.081 561.514 247.866 570.107C223.806 579.454 200.506 581.991 181.401 581.734C178.972 581.702 176.592 581.622 174.309 581.509C154.199 580.514 139.902 576.675 136.259 575.599C136.243 575.599 136.21 575.583 136.194 575.583C133.587 574.668 131.029 573.704 128.503 572.692C113.866 566.878 100.508 559.716 88.4295 551.734C54.5732 529.378 30.7071 500.662 17.1873 477.551C-12.524 426.8 -16.6204 366.429 -17.6729 340.893C-16.4909 359.973 -7.958 438.958 50.072 495.024C61.6003 506.17 74.5696 515.052 88.4295 521.54C101.172 527.515 114.676 531.481 128.503 533.377C135.304 534.308 142.185 534.742 149.099 534.661C157.292 534.565 165.954 534.003 174.309 532.59C176.705 532.188 179.069 531.722 181.401 531.16C185.108 530.293 188.703 529.233 192.103 527.932C215.678 518.938 233.845 506.572 247.866 491.025C276.25 459.547 286.941 423.269 292.393 358.833C292.976 351.943 293.316 317.204 293.316 317.204V123.002C293.316 123.002 369.593 66.4536 377.22 60.9609V319.838C377.22 319.838 378.094 346.771 376.798 371.649Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M443.135 120.507V363.259C443.135 365.861 443.087 368.543 442.989 371.273C439.719 466.287 379.81 533.033 313.75 565.636C293.753 575.497 273.206 582.226 253.501 585.679C251.607 586.017 249.729 586.306 247.867 586.579C223.256 590.192 200.167 589.036 181.401 586.386C178.956 586.049 176.592 585.679 174.309 585.294C171.605 584.844 169.014 584.362 166.553 583.865C163.153 583.174 159.996 582.467 157.081 581.777C155.754 581.455 154.491 581.134 153.293 580.829C152.078 580.508 150.912 580.203 149.811 579.898C141.376 577.585 136.227 575.658 135.45 575.352C135.579 575.385 135.822 575.465 136.194 575.577C136.211 575.577 136.243 575.593 136.259 575.593C139.902 576.669 154.199 580.508 174.309 581.504C176.592 581.616 178.972 581.696 181.401 581.728C200.507 581.985 223.806 579.448 247.867 570.101C270.081 561.508 292.96 547.086 313.75 523.718C337.599 496.898 359.183 460.039 372.994 403.073C373.593 400.792 374.111 398.175 374.548 395.3C374.581 395.187 374.597 395.059 374.597 394.946C375.633 388.346 376.313 380.492 376.75 372.366C376.75 372.125 376.799 371.643 376.799 371.643L377.22 319.832V60.5215C377.22 60.5215 377.317 60.6018 377.495 60.7624C377.576 60.8427 377.689 60.9391 377.835 61.0675C384.506 67.042 443.135 120.314 443.135 120.507Z",
    fill: "#99CBC7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_273_35693",
    x: 80.3354,
    y: 179.801,
    width: 44.5731,
    height: 162.566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.39921,
    dy: 5.39921
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.24967
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_273_35693"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.39921
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.59948
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_273_35693",
    result: "effect2_innerShadow_273_35693"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_273_35693",
    x: 166.214,
    y: 208.42,
    width: 78.057,
    height: 299.561,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.39921,
    dy: 5.39921
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.24967
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_273_35693"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.39921
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.59948
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_273_35693",
    result: "effect2_innerShadow_273_35693"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_273_35693",
    x: -17.6729,
    y: 60.9609,
    width: 399.68,
    height: 526.19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.39921,
    dy: 5.39921
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.24967
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_273_35693"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.39921
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.59948
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_273_35693",
    result: "effect2_innerShadow_273_35693"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_273_35693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 470.487,
    height: 537.7,
    fill: "white",
    transform: "translate(-21.4619 18.6387)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_273_35693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 470.487,
    height: 537.7,
    fill: "white",
    transform: "translate(-27.5732 18.6504)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarBg);
export default __webpack_public_path__ + "static/media/navbar_bg.d336894d44285e73ea0c00c91891f317.svg";
export { ForwardRef as ReactComponent };